/**
 * shadcn Badge (Tailwind 3 "new-york"), ported per the checklist in
 * agents/CODING_STANDARDS.md -> "Styling: two systems". The small MUI Chip's
 * replacement: a `span`, so it sits in running text and table cells. Solid
 * `success`, `warning` and `info` variants on the palette tokens join
 * shadcn's four. shadcn dims `default`, `secondary` and `destructive` on
 * hover; a badge here is never clickable, so none of them react to it.
 */
import React from 'react'
import { cva } from 'class-variance-authority'

import { cn } from '../../utils/cn.js'

const badgeVariants = cva(
  'tw-inline-flex tw-items-center tw-whitespace-nowrap tw-rounded-full tw-border tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold tw-leading-4 tw-transition-colors focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring',
  {
    variants: {
      variant: {
        default:
          'tw-border-transparent tw-bg-primary tw-text-primary-foreground tw-shadow',
        secondary:
          'tw-border-transparent tw-bg-secondary tw-text-secondary-foreground',
        destructive:
          'tw-border-transparent tw-bg-destructive tw-text-destructive-foreground tw-shadow',
        outline: 'tw-text-foreground',
        success:
          'tw-border-transparent tw-bg-success tw-text-success-foreground tw-shadow',
        warning:
          'tw-border-transparent tw-bg-warning tw-text-warning-foreground tw-shadow',
        info: 'tw-border-transparent tw-bg-info tw-text-info-foreground tw-shadow',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

const Badge = React.forwardRef(({ className, variant, ...props }, ref) => (
  <span
    ref={ref}
    data-slot="badge"
    className={cn(badgeVariants({ variant }), className)}
    {...props}
  />
))
Badge.displayName = 'Badge'

export { Badge, badgeVariants }
